import axios from 'axios'
import { User } from '../../interfaces'

export const updateUser = (user: User) => {
  return axios.put('/data/sadarbības_partnera_personas/' + user.id, user)
}
